import type { Component } from 'vue'

class StepResolver {
  private stepsRegistry: Record<string, () => Promise<{ default: Component }>> =
    {
      welcome: () =>
        import('@/modules/wizard/components/steps/WelcomeStep.vue'),
      course_selection: () =>
        import('@/modules/wizard/components/steps/CourseSelectionStep.vue'),
      questions: () =>
        import('@/modules/wizard/components/steps/QuestionsStep.vue'),
      foreign_languages: () =>
        import('@/modules/wizard/components/steps/ForeignLanguagesStep.vue'),
      intake_interests: () =>
        import('@/modules/wizard/components/steps/IntakeInterestsStep.vue'),
      hzb_select: () =>
        import('@/modules/wizard/components/steps/HzbSelectStep.vue'),
      hzb_document_upload: () =>
        import('@/modules/wizard/components/steps/HzbDocumentUploadStep.vue'),
      email_verification: () =>
        import('@/modules/wizard/components/steps/EmailVerificationStep.vue'),
      password_setup: () =>
        import('@/modules/wizard/components/steps/PasswordSetupStep.vue'),
      language_proficiency_selection: () =>
        import(
          '@/modules/wizard/components/steps/LanguageProficiencySelectionStep.vue'
        ),
      language_proficiency_insufficient: () =>
        import(
          '@/modules/wizard/components/steps/LanguageProficiencyInsufficientStep.vue'
        ),
      success: () =>
        import('@/modules/wizard/components/steps/SuccessStep.vue'),
      consultation_booking: () =>
        import('@/modules/wizard/components/steps/ConsultationBookingStep.vue'),
      language_certificate_upload: () =>
        import(
          '@/modules/wizard/components/steps/LanguageCertificateUploadStep.vue'
        ),
      consultation_rebooking: () =>
        import(
          '@/modules/wizard/components/steps/ConsultationRebookingStep.vue'
        ),
      ready_to_move: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/ReadyToMove.vue'
        ),
      study_campus: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/StudyCampus.vue'
        ),
      drivers_license: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/DriversLicenseStep.vue'
        ),
      car_availability: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/CarAvailabilityStep.vue'
        ),
      matching_criteria_success: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/Success.vue'
        ),
      bwl_specialization: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/BwlSpecializationStep.vue'
        ),
      distance_commute: () =>
        import(
          '@/modules/wizard/components/steps/matching-criteria/DistanceCommuteStep.vue'
        ),
    }

  public resolve(stepId: string): () => Promise<{ default: Component }> {
    const componentLoader = this.stepsRegistry[stepId]

    if (!componentLoader) {
      throw new Error(`Step with ID '${stepId}' is not registered.`)
    }

    return componentLoader
  }
}

export default new StepResolver()
